import { FC, useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

import styles from './CookieModal.module.scss'

import { ReactComponent as CookieIcon } from 'assets/svg/cookie.svg'
import classNames from 'classnames'

type CookieModalProps = {
  show: boolean
  setShow: (show: boolean) => void
}

const CookieModal: FC<CookieModalProps> = ({ show, setShow }) => {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    if (show) {
      const timer = setTimeout(() => {
        setIsVisible(true)
      }, 700)

      return () => clearTimeout(timer)
    }
  }, [show])

  const handleAcceptAll = () => {
    localStorage.setItem('cookieConsent', 'all')
    setIsVisible(false)

    setTimeout(() => {
      setShow(false)
    }, 3000)
  }

  const handleReject = () => {
    localStorage.setItem('cookieConsent', 'essential')
    setIsVisible(false)

    setTimeout(() => {
      setShow(false)
    }, 3000)
  }

  return createPortal(
    <>
      {show && (
        <div
          className={classNames(styles.wrapper, {
            [styles.wrapper__active]: isVisible,
          })}
        >
          <div className={styles.header}>
            <CookieIcon />
            <h2 className={styles.header__title}>Cookies Settings</h2>
          </div>
          <p className={styles.text}>
            We use cookies to ensure you get the best experience on our website.
            <a href='https://www.cookiesandyou.com/' target='_blank' rel='noopener noreferrer'>
              Learn more
            </a>
          </p>
          <div className={styles.footer}>
            <button onClick={handleReject}>Decline</button>
            <button onClick={handleAcceptAll}>Accept All</button>
          </div>
        </div>
      )}
    </>,
    document.body
  )
}

export default CookieModal
